module.exports = __webpack_public_path__ + "img/shape-2_gray-500.2517a3d.png";